// extracted by mini-css-extract-plugin
module.exports = {"card":"WalletCard_card__37zd1","card-title":"WalletCard_card-title__6VS2a"};